module.exports = __webpack_public_path__ + "img/PriorityToday.4ba3d6ef.svg";